import { skipToken, useQuery } from "@tanstack/react-query";

import { getFarmDocScanField } from "services";

import { GET_FARM_DOC_SCAN_FIELD } from "consts";

import { GetFarmDocScanFieldResponse } from "models";

export const useGetFarmDocScanField = ({ farmId, scanFieldId }: { farmId: string; scanFieldId: string | undefined }) =>
  useQuery<GetFarmDocScanFieldResponse>({
    queryKey: [GET_FARM_DOC_SCAN_FIELD, farmId, scanFieldId],
    queryFn: farmId && scanFieldId ? async () => getFarmDocScanField({ farmId, scanFieldId }) : skipToken,
    staleTime: 1000 * 60 * 5,
  });
